import {
  GenerateEvaluationFormPdfRequest,
  EvaluationDetailDto,
  UpdateEvaluationRequest,
  IList,
  List,
  IListResult,
  ListResultDto,
  IPagedResult,
  PagedResultDto,
  Dictionary,
  IDictionary,
  Response,
  AdvancedQueryPage,
  OptionItemDto,
  IRequestOptions,
  IRequestConfig,
  getConfigs,
  axios,
  basePath
} from './index.defs';

export class EvaluationsService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   *
   */
  static generateEvaluationForm(
    params: {
      /**  */
      id: number;
      /** requestBody */
      body?: GenerateEvaluationFormPdfRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/evaluations/{id}/generate-evaluation-form';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json-patch+json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getByJobId(
    params: {
      /**  */
      jobId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<EvaluationDetailDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/evaluations/job/{jobId}';
      url = url.replace('{jobId}', params['jobId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /**  */
      id: number;
      /** requestBody */
      body?: UpdateEvaluationRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<EvaluationDetailDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/evaluations/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json-patch+json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}
